module.exports = __webpack_public_path__ + "img/ml2.460a79c5.jpg";